// Import Bootstrap javascript
import 'bootstrap';
// import 'bootstrap/js/dist/util'
// import 'bootstrap/js/dist/dropdown'
// import 'bootstrap/js/dist/button'
// import 'bootstrap/js/dist/collapse'
// import 'bootstrap/js/dist/modal'

// Import custom styles
import '../scss/adobe_vip.scss';
import '../scss/cot_creative_vip.scss';

import './sendform.js';
//
import './offcanvas.js';

import './adobe_vip_form_check';

// Enabling HMR
if (module.hot) {
    module.hot.accept(console.log('Aceptando nuevos cambios...'));
}
